(function () {
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('[data-buy-now-popup]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      document.getElementById('buy-popup-step1').style.display = 'block';
    },
    true
  );

  window.buyPopupNo = function () {
    closeAllPopups();
    addToCartAndCheckout();
  };

  window.buyPopupYes = function () {
    document.getElementById('buy-popup-step1').style.display = 'none';
    document.getElementById('buy-popup-step2').style.display = 'block';
  };

  window.buyPopupAgree = function () {
    closeAllPopups();
    addToCartAndCheckout();
  };

  window.buyPopupCancel = function () {
    closeAllPopups();
  };

  function closeAllPopups() {
    document.getElementById('buy-popup-step1').style.display = 'none';
    document.getElementById('buy-popup-step2').style.display = 'none';
  }

  function addToCartAndCheckout() {
    const variantId = document.querySelector('.product-variant-id')?.value;
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(() => {
        window.location.href = '/checkout';
      });
  }
})();